import {useMessages} from "i18n";
import Seo from "../seo/Seo";
import {ContentSurface, Prose} from "../components/ContentPage";
import TermsAndConditions from "../legal/TermsAndConditions";

/**
 * Public, pre-rendered Terms & Conditions page (ui#97). Renders the SAME
 * {@link TermsAndConditions} content the "Resources" menu's dialog shows — one source, two surfaces
 * — as in-flow SSG markup so the terms are crawlable instead of hidden behind a portal.
 */
export function Component() {
	const {resourceTitles, seo} = useMessages();
	return (
		<>
			<Seo
				title={seo.terms.title}
				description={seo.terms.description}
				path="/terms"
			/>
			<ContentSurface>
				<Prose>
					<h1>{resourceTitles.terms}</h1>
					<TermsAndConditions/>
				</Prose>
			</ContentSurface>
		</>
	);
}
